import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import { createPinia } from 'pinia';
import UniqueId from './vue/plugins/vue-unique-id.js';

import commentService from './vue/plugins/commentservice.js';
import staffservice from './vue/plugins/staffservice.js';

import comments from './vue/comments.vue';
import staffcatalog from './vue/staffcatalog/staffcatalog.vue';
import IdRelayContainer from './vue/IdRelay/IdRelayContainer.vue';
import AstaSearch from './vue/Asta/AstaSearch.vue';
import AstaResult from './vue/Asta/AstaResult.vue';
import ArtviseCaseForm from './vue/ArtviseCase/ArtviseCaseForm.vue';
import HittaTipsSida from './vue/kunskapsbanken/HittaTipsSida.vue';
import HanteraTipsSida from './vue/kunskapsbanken/HanteraTipsSida.vue';

const components = {
  comments: 'comments',
  staffcatalog: 'staffcatalog',
  astasearch: 'asta-search',
  astaresult: 'asta-result',
  idrelay: 'idrelay-container',
  artvisecaseform: 'artvise-case-form',
  hittatipssida: 'hitta-tips-sida',
  hanteratipssida: 'hantera-tips-sida',
}
const VuecomponentList = [
  { container: components.comments, component: comments },
  { container: components.staffcatalog, component: staffcatalog },
  { container: components.astasearch, component: AstaSearch },
  { container: components.astaresult, component: AstaResult },
  { container: components.idrelay, component: IdRelayContainer },
  { container: components.artvisecaseform, component: ArtviseCaseForm },
  { container: components.hittatipssida, component: HittaTipsSida },
  { container: components.hanteratipssida, component: HanteraTipsSida },
];

function initVueComponent(item: any) {
  var pagebottomTAG = item.container,
    pagebottomDOMs = document.querySelectorAll(pagebottomTAG);
  pagebottomDOMs.forEach((pagebottomDOM) => {
    if (pagebottomDOM) {
      var rawoptions = pagebottomDOM.getAttribute('data-settings'),
        options = {};
      if (rawoptions) {
        options = JSON.parse(rawoptions);
      }
      if (item.container === components.staffcatalog) {
        const routes = [{ path: '/', component: staffcatalog, default: true }];
        const router = createRouter({ history: createWebHistory(), routes: routes }); // new VueRouter({ routes });
        createApp(item.component, { ...options })
          .use(router)
          .use(createPinia())
          .use(staffservice)
          .mount(item.container);
      } else if (item.container === components.astasearch) {
        createApp(item.component, { ...options }).mount(item.container);
      } else if (item.container === components.hanteratipssida) {
        createApp(item.component, { ...options }).mount(item.container);
      } else if (item.container === components.hittatipssida) {
        const routes = [{ path: window.location.pathname, component: HittaTipsSida, default: true }];
        const router = createRouter({ history: createWebHistory(), routes:routes });
        createApp(item.component, { ...options })
        .use(router)
        .mount(item.container);
      } else {
        createApp(item.component, { ...options })
          .use(createPinia())
          .use(commentService)
          .use(UniqueId)
          .mount(item.container);
      }
    }
  });
}

uhr.ready((_w, _$) => {
  VuecomponentList.forEach((item) => {
    initVueComponent(item);
  });
});
